import { render } from "./UiSvgIcon.vue?vue&type=template&id=222a142a&scoped=true&lang=pug"
import script from "./UiSvgIcon.vue?vue&type=script&lang=js"
export * from "./UiSvgIcon.vue?vue&type=script&lang=js"

import "./UiSvgIcon.vue?vue&type=style&index=0&id=222a142a&lang=sass&scoped=true"

import exportComponent from "/home/runner/work/valeriya-artist/valeriya-artist/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-222a142a"]])

export default __exports__